/**
 * Şirketin tahsilat hesapları.
 *
 * Ürün Sahibi, 21.09.2026 CRM satış incelemesi: "satış ekranında link üretebilmesi lazım müşteri
 * temsilcisinin, adam nasıl satış yapacak link olmazsa, orada banka bilgileri de olacak, UAE ve
 * Türkiye." Hesaplar o gün verildi.
 *
 * **Neden kodda, veritabanında değil.** Bugün tek tüketici satış ekranı ve hesaplar yılda bir
 * değişiyor. Yapılandırılabilir bir koleksiyon (DTO, servis, yönetim ekranı) açmak, bir kez
 * yazılıp bir daha okunmayacak bir yüzey demek olurdu. Fatura tarafı da bu bilgileri istediği
 * gün burası API'ye taşınır ve iki yerde iki ayrı IBAN durmaz; o gün gelene kadar tek kopya
 * burada.
 *
 * **Neden gizli değil.** Bunlar tahsilat hesapları: müşteriye zaten söyleniyor, faturada zaten
 * yazıyor. Parola, jeton ve bağlantı dizesi yasağı bunları kapsamıyor.
 *
 * Ayrı tüzel kişiliklerin hesapları kendi unvanları altında gösterilir.
 * 03.10.2026: Ürün Sahibi MBD Travel Turizm Limited Şirketi için TL/USD/EUR/GBP
 * İş Bankası Dünya Ticaret Merkezi Şubesi hesaplarını ayrıca iletti.
 * BAE hesabı AED, Türkiye hesapları TL/USD/EUR/GBP içindir.
 * Para birimi her IBAN satırında belirtilir.
 */

export interface BankaSatiri {
  readonly etiket: string;
  readonly deger: string;
  /** Kopyalanabilir mi. Şube adı kopyalanmaz, IBAN kopyalanır. */
  readonly kopyalanir: boolean;
}

export interface BankaHesabi {
  readonly anahtar: string;
  readonly baslik: string;
  readonly unvan: string;
  readonly satirlar: readonly BankaSatiri[];
}

export const BANKA_HESAPLARI: readonly BankaHesabi[] = [
  {
    anahtar: 'bae',
    baslik: 'Birleşik Arap Emirlikleri',
    unvan: 'MBD TOURISM LLC',
    satirlar: [
      { etiket: 'Banka', deger: 'Emirates NBD', kopyalanir: false },
      { etiket: 'Şube', deger: 'Business Bay Branch', kopyalanir: false },
      { etiket: 'Para birimi', deger: 'AED', kopyalanir: false },
      { etiket: 'Hesap numarası', deger: '1015888835501', kopyalanir: true },
      { etiket: 'IBAN', deger: 'AE200260001015888835501', kopyalanir: true },
      { etiket: 'BIC', deger: 'EBILAEADXXX', kopyalanir: true },
    ],
  },
  {
    anahtar: 'mbd-travel-turkiye',
    baslik: 'Türkiye · MBD Travel',
    unvan: 'MBD Travel Turizm Limited Şirketi',
    satirlar: [
      { etiket: 'Banka', deger: 'Türkiye İş Bankası', kopyalanir: false },
      { etiket: 'Şube', deger: 'Dünya Ticaret Merkezi Şubesi', kopyalanir: false },
      { etiket: 'IBAN, TL', deger: 'TR65 0006 4000 0011 1770 2425 34', kopyalanir: true },
      { etiket: 'IBAN, USD', deger: 'TR95 0006 4000 0021 1770 1035 70', kopyalanir: true },
      { etiket: 'IBAN, EUR', deger: 'TR08 0006 4000 0021 1770 1035 84', kopyalanir: true },
      { etiket: 'IBAN, GBP', deger: 'TR07 0006 4000 0021 1770 1036 02', kopyalanir: true },
    ],
  },
];
